"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Pointer = _interopRequireWildcard(require("./Pointer.js"));

var _functions = require("../functions.js");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/interaction/PinchZoom
 */


/**
 * @typedef {Object} Options
 * @property {number} [duration=400] Animation duration in milliseconds.
 */

/**
 * @classdesc
 * Allows the user to zoom the map by pinching with two fingers
 * on a touch screen.
 * @api
 */
var PinchZoom =
/** @class */
function (_super) {
  __extends(PinchZoom, _super);
  /**
   * @param {Options} [opt_options] Options.
   */


  function PinchZoom(opt_options) {
    var _this = this;

    var options = opt_options ? opt_options : {};
    var pointerOptions =
    /** @type {import("./Pointer.js").Options} */
    options;

    if (!pointerOptions.stopDown) {
      pointerOptions.stopDown = _functions.FALSE;
    }

    _this = _super.call(this, pointerOptions) || this;
    /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */

    _this.anchor_ = null;
    /**
     * @private
     * @type {number}
     */

    _this.duration_ = options.duration !== undefined ? options.duration : 400;
    /**
     * @private
     * @type {number|undefined}
     */

    _this.lastDistance_ = undefined;
    /**
     * @private
     * @type {number}
     */

    _this.lastScaleDelta_ = 1;
    return _this;
  }
  /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */


  PinchZoom.prototype.handleDragEvent = function (mapBrowserEvent) {
    var scaleDelta = 1.0;
    var touch0 = this.targetPointers[0];
    var touch1 = this.targetPointers[1];
    var dx = touch0.clientX - touch1.clientX;
    var dy = touch0.clientY - touch1.clientY; // distance between touches

    var distance = Math.sqrt(dx * dx + dy * dy);

    if (this.lastDistance_ !== undefined) {
      scaleDelta = this.lastDistance_ / distance;
    }

    this.lastDistance_ = distance;
    var map = mapBrowserEvent.map;
    var view = map.getView();

    if (scaleDelta != 1.0) {
      this.lastScaleDelta_ = scaleDelta;
    } // scale anchor point.


    var viewportPosition = map.getViewport().getBoundingClientRect();
    var centroid = (0, _Pointer.centroid)(this.targetPointers);
    centroid[0] -= viewportPosition.left;
    centroid[1] -= viewportPosition.top;
    this.anchor_ = map.getCoordinateFromPixelInternal(centroid); // scale, bypass the resolution constraint

    map.render();
    view.adjustResolutionInternal(scaleDelta, this.anchor_);
  };
  /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */


  PinchZoom.prototype.handleUpEvent = function (mapBrowserEvent) {
    if (this.targetPointers.length < 2) {
      var map = mapBrowserEvent.map;
      var view = map.getView();
      var direction = this.lastScaleDelta_ > 1 ? 1 : -1;
      view.endInteraction(this.duration_, direction);
      return false;
    } else {
      return true;
    }
  };
  /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */


  PinchZoom.prototype.handleDownEvent = function (mapBrowserEvent) {
    if (this.targetPointers.length >= 2) {
      var map = mapBrowserEvent.map;
      this.anchor_ = null;
      this.lastDistance_ = undefined;
      this.lastScaleDelta_ = 1;

      if (!this.handlingDownUpSequence) {
        map.getView().beginInteraction();
      }

      return true;
    } else {
      return false;
    }
  };

  return PinchZoom;
}(_Pointer["default"]);

var _default = PinchZoom;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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